import * as React from 'react';
import { Spinner } from '@cian/ui-kit';

import { PageHeaderContainer } from '../PageHeader';
import { PageWithSidebar as Layout } from '../../components/Layouts';
import { SidebarAddBlogPostTips } from '../../components/SidebarAddPostTips';
import { SidebarAddBlogPostTip } from '../../components/SidebarAddPostTip';

/**
 * Контейнер формы добавления поста блога
 */
export const AddBlogPageContainer = () => {
  return (
    <Layout header={<PageHeaderContainer />} body={<Spinner size={40} />}>
      <SidebarAddBlogPostTips />
      <SidebarAddBlogPostTip />
    </Layout>
  );
};
